import { IGetStatInformationByIdObraUseCase } from "../../../presentation/useCases/read/get_stat_information_by_id_obra_use_case";
import { StatInformation } from "../../models/stat_information";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetStatInformationByIdObraUseCase
 */

export class GetStatInformationByIdObraUseCase implements IGetStatInformationByIdObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getStatInformationByIdObra(
    idObra: number | undefined,
  ): Promise<StatInformation> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');
    return await this.repository.getStatInformationByIdObra(idObra);
  }
}
